import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React,{lazy,Suspense} from 'react';
import ReactDOM from 'react-dom';
import { withStyles } from "@material-ui/core/styles";
import './index.css';
//import App from './App';
import * as serviceWorker from './serviceWorker';

const App = lazy(() => import('./App'));

const styles = theme => ({
    "@global": {
      // MUI typography elements use REMs, so you can scale the global
      // font size by setting the font-size on the <html> element.
      html: {
        fontSize: 14,
        [theme.breakpoints.up("sm")]: {
          fontSize: 16
        },
        [theme.breakpoints.up("md")]: {
          fontSize: 18
        },
        [theme.breakpoints.up("lg")]: {
          fontSize: 20
        }
      }
    }
  });


const StyleApp = withStyles(styles)(App)
ReactDOM.render(<Suspense fallback={<div></div>}><StyleApp /></Suspense>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
//serviceWorker.unregister();

if ('serviceWorker' in navigator) {
  caches.keys().then(function(cacheNames) {
    cacheNames.forEach(function(cacheName) {
      caches.delete(cacheName);
    });
  });
}
